export default __webpack_public_path__ + "static/media/law-b.9ef98469.png";